<template>
    <div class="vehicle-image__container">
        <img v-bind:class="{ 'vehicle-image__blurred': blurred }" class="vehicle-image__trimmed"
            :src="chatMessage.options.imageURL" />
    </div>
</template>

<script lang="ts">
import ChatMessage from '@/models/vehicle/makeModelBot/chatMessage';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    components: {

    }
})
export default class MakeModelVehicleImageComponent extends Vue {
    @Prop({ default: '' })
    public chatMessage!: ChatMessage;

    @Prop({ default: false })
    public blurred!: boolean;

    public mounted() {
        this.chatMessage.isFinished = true;
    }
}
</script>
